var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { height: "100%" } }, [
    _c("div", { staticClass: "grid-view", staticStyle: { height: "100%" } }, [
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          {
            staticClass: "app-main-inner-row",
            staticStyle: { height: "100%" }
          },
          [
            _c(
              "div",
              {
                staticClass: "section grid-wrapper",
                staticStyle: {
                  width: "15%",
                  "min-width": "190px",
                  border: "1px solid #ccc",
                  display: "flex",
                  cursor: "pointer"
                }
              },
              [
                _c("cargo-ag-grid", {
                  staticStyle: {
                    width: "100%",
                    height: "100%",
                    "min-height": "500px"
                  },
                  attrs: {
                    "show-side-bar": false,
                    "grid-options": _vm.lobTree.gridOptions,
                    "column-defs": _vm.lobTree.columnDefs,
                    "row-data": _vm.lobTree.rowData
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "section grid-wrapper",
                staticStyle: {
                  "min-width": "85%",
                  border: "1px solid #ccc",
                  display: "flex"
                }
              },
              [
                _c("tenant-instruction", {
                  ref: "tenantInstruction",
                  attrs: {
                    "data-type": _vm.lobTree.selectRow.dataType,
                    "instruction-lob":
                      _vm.lobTree.selectRow.dataType ===
                      _vm.INSTRUCTION_TREE_DATE_TYPE_LOB.code
                        ? _vm.lobTree.selectRow.code
                        : _vm.lobTree.selectRow.parentCode,
                    "instruction-type":
                      _vm.lobTree.selectRow.dataType ===
                      _vm.INSTRUCTION_TREE_DATE_TYPE_LOB.code
                        ? ""
                        : _vm.lobTree.selectRow.code,
                    "platform-instructions": _vm.platformInstructions,
                    "mail-templates": _vm.mailTemplates,
                    templates: _vm.templates
                  }
                })
              ],
              1
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }